import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { Address, Contact, Copy, Customer, CustomerInfo, Edituser, EmailBox, Phone, Shipping, ShippingID, ShippingMethod, Users, View } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { exportDataExcel, fomateDate, handleCopy } from '../../utils/fomateDate';
import {

    MenuItem,
    Menu,
    Button,
    Paper,
    Typography,
    Box,
    Divider, Grid,
    Chip
} from "@mui/material";
import OrderDetailsProds from '../../component/ordersComps/OrderDetailsProds';
import { ArrowDropDown, Close, Opacity, Refresh } from '@mui/icons-material';
import { orderDetailsThunk, setorderrefresh } from '../../redux/orderSlice';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import UserHeader from '../../component/reusable/UserHeader';
import CancelModal from '../../component/reusable/cancelModal/CancelModal';
import BomQuote from './BomQuote/BomQuote';
import { bomOrderDetailsThunk, setbomOrderrefresh } from '../../redux/bomOrderSlice';
import BomListTable from '../../component/bomComps/BomListTable/BomListTable';
import styless from '../../component/bomComps/BomListTable/bomListTable.module.css';
import { getMatchedProductsThunk, getSuppliersThunk } from '../../redux/bomSlice';
import SuppliersQuote from './SuppliersQuote';
import { VendorOrderDetailsThunk } from '../../redux/vendor/vendororderSlice';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const New = styled(Chip)(({ theme }) => ({
    backgroundColor: '#4A4C561A',
    color: '#4A4C56',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: '#F86624',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));


const Cancelled = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: 'red',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
    backgroundColor: '#EAF8FF',
    color: '#2BB2FE',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
    backgroundColor: '#E9FAF7',
    color: '#1A9882',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));





// const status = [
//     "NEW", "PROCESSING", "PENDING", "SHIPPED", "DELIVERED"
// ]

const VendorOrderDetails = () => {
    const { macthedProducts, suppliers } = useSelector((state) => state.bom)
    const [showSupplier, setShowSupplier] = useState(false)
   

    const { loading, refresh, orderDetails } = useSelector((state) => state.vendorOrder);

    const [productData, setProductData] = useState([]);

    console.log(orderDetails);



    const dispatch = useDispatch()
    const { id } = useParams()


    useEffect(() => {
        setProductData(orderDetails?.partList)
    }, [orderDetails])

    useEffect(() => {
        const data = [productData]
        console.log("data",data);
        
        dispatch(getMatchedProductsThunk(data))
    }, [productData])

    useEffect(() => {
        dispatch(VendorOrderDetailsThunk(id))
    }, [refresh])

  
    console.log(orderDetails);


    const exportOrderDetails = async () => {

        const exportdata = {
            'id': orderDetails?._id || '-',
            'customer Name': orderDetails?.vendorId?.fullName || '-',
            'Customer Email': orderDetails?.vendorId?.email || '-',
            'productNumbers': orderDetails.products
                .flatMap((product) =>
                    product.productDetails?.productOverview?.productNumber || []
                )
                .join(", "),
            'Sub Total': orderDetails?.priceBreakup?.subTotal || '-',
            'Tax': orderDetails?.priceBreakup?.tax || '-',
            'Other Charges': orderDetails?.priceBreakup?.otherCharges || '-',
            'Total': orderDetails?.priceBreakup?.total || '-',
            'Status': orderDetails?.status || '-',
            'CreatedAt': fomateDate(orderDetails?.createdAt)
        }
        console.log("expo", exportdata);
        // console.log("orderde", orderDetails);

        exportDataExcel([exportdata], "ordersdetails")
    }


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Loading....
            </div>
        )
    }





 
    
  

    const handleView = (index) => {
        const product = productData[index];
        console.log(product);
        dispatch(getSuppliersThunk(`?productNumber=${product?.productNumber}&quotePrice=${product?.quotePrice}&moq=${product?.moq}`))
        setShowSupplier(true)
    }

    // console.log(macthedProducts);

    return (
        <>

            <UserHeader
                index={`Order #${orderDetails?._id}`}
                root="Dashboard"
                buttonText={'Add Vendor'}
                showHeader={'orderDetails'}
                exportData={exportOrderDetails}
            />
            <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
                <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography
                            sx={{
                                color: 'rgba(29, 31, 44, 1)',
                                fontSize: '20px',
                                fontWeight: '600',
                                fontFamily: `'Public Sans', sans-serif`,
                            }}>
                            Order #{orderDetails?._id}
                        </Typography>
                        <Typography style={{
                            marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
                            color: '#01A1FE',
                            background: "#EFF9FF",

                        }}>
                            {orderDetails?.status === "NEW" ? (
                                <New label="New" size="small" />
                            ) : orderDetails?.status === "DELIVERED" ? (
                                <Delivered label="Delivered" size="small" />
                            ) : orderDetails?.status === "PROCESSING" ? (
                                <Processing label="Processing" size="small" />
                            ) : orderDetails?.status === "CANCELLED" ? (
                                <Cancelled label="Cancelled" size="small" />
                            ) : (
                                <Shiped label="shipped" size="small" />
                            )}
                        </Typography>
                    </div>
                    {/* <div>

                        <ActionCancelButton
                            sx={{
                                color: '#fff',
                                border: '1px solid #F43224',
                                background: '#F43224',
                                borderRadius: '8px',
                            }}
                            onClick={() => setCancelModal(!cancelModal)}
                        >Cancel order
                        </ActionCancelButton>

                        <ActionButton
                            onClick={handleClick}
                            sx={{
                                color: '#667085',
                                border: '1px solid #E0E2E7',
                                background: '#fff',
                                borderRadius: '8px',
                            }}
                        >
                            Status
                            <ArrowDropDown />
                        </ActionButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleClose('')}
                            MenuListProps={{
                                'aria-labelledby': 'status-button',
                            }}
                        >
                            {
                                status?.map((i) => (
                                    <MenuItem onClick={() => handleClose(i)}
                                        sx={{
                                            borderBottom: '1px solid #E6E1E5',
                                            fontSize: '14px',
                                            color: '#667085',
                                            textTransform: 'capitalize'
                                        }}>
                                        {i}
                                    </MenuItem>
                                ))
                            }


                        </Menu>
                    </div> */}
                </div>

                {loading ? <div>Please wait...</div> :
                    <Box maxWidth="lg">

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <CustomerInfo />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Vendor Info
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                                        <Customer />
                                        <Box style={{ marginLeft: '8px', }}>
                                            <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                Customer
                                            </Typography>
                                            <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                {orderDetails?.vendorId?.companyName}
                                            </Typography></Box>
                                    </Box>
                                </Paper>
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <Contact />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Contact
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <EmailBox />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Email
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.vendorId?.email}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.vendorId?.email)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Phone />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Phone Number
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.vendorId?.phone}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.vendorId?.phone)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>

                          

                        </Grid>

                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2 }} display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
                                <Box>
                                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#1D1F2C' }}>
                                        Vendor purchase order
                                    </Typography>
                                    <Typography sx={{ mt: '4px', fontSize: '13px', color: '#727A90' }}>
                                        {orderDetails?.vendorPurchaseOrder?.uri
                                            ? `${orderDetails.vendorPurchaseOrder.fileName || 'Purchase-order PDF'} uploaded by the vendor`
                                            : 'The vendor has not uploaded a purchase-order PDF yet.'}
                                    </Typography>
                                </Box>
                                {orderDetails?.vendorPurchaseOrder?.uri ? (
                                    <Button
                                        component="a"
                                        href={orderDetails.vendorPurchaseOrder.uri}
                                        target="_blank"
                                        rel="noreferrer"
                                        variant="contained"
                                        sx={{ textTransform: 'none', background: '#512DA8', '&:hover': { background: '#4527A0' } }}
                                    >
                                        View PO PDF
                                    </Button>
                                ) : (
                                    <Chip label="PO pending" size="small" sx={{ background: '#FFF8E6', color: '#B7791F', fontWeight: 600 }} />
                                )}
                            </Box>
                        </Paper>

                        {/* <BomQuote /> */}
                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                                <Box display="flex" alignItems="center" >
                                    <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                                        {productData?.length} Products
                                    </Typography>
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
                                        Quoted date: {fomateDate(orderDetails?.createdAt)}
                                    </Typography>
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: orderDetails?.status === "NEW" ? "#4A4C56" : orderDetails?.status === "QUOTED" ? "#00B789" : "#1A9882" }}>
                                        {orderDetails?.status}
                                    </Typography>

                                </Box>

                            
                            </Box>

                            <div className={styless.quoteTables}>
                                <div className={styless.quoteProductsPane}>

                                    <BomListTable
                                        products={macthedProducts}
                                        show={true}
                                    />


                                </div>
                                <div className={`${styless.quoteInputsPane} ${styless.orderQuoteInputsPane} ${styless.vendorQuoteInputsPane}`}>
                                    <table className={`${styless.productTable22} ${styless.quoteInputsTable}`}>
                                        <thead className={styless.productTableHead22}>
                                            <tr style={{height: 30}}>
                                                <th>Quote Price</th>
                                                <th>MOQ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* {productData?.map((product, index) => ( */}
                                                <tr>
                                                    <td className={styless.tdBorder}>
                                                        <input
                                                            type="text"
                                                            placeholder="-"
                                                            className={`${styless.dataInput} ${styless.quoteReadonlyInput}`}
                                                            value={orderDetails?.partList?.quotePrice ?? ""} // Default empty if not present
                                                            // onChange={(e) => handleChange(index, "quotePrice", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td className={styless.tdBorder}>
                                                        <input
                                                            type="text"
                                                            placeholder="-"
                                                            className={`${styless.dataInput} ${styless.quoteReadonlyInput}`}
                                                            value={orderDetails?.partList?.moq ?? ""} // Default empty if not present
                                                            // onChange={(e) => handleChange(index, "moq", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </td>

                                                </tr>
                                            {/* ))} */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                           
                        </Paper>

                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                                <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                                    Grand Total :
                                </Typography>
                                <Typography style={{ marginRight: '10px', fontSize: '18px', fontWeight: "600", }}>
                                    {orderDetails?.total || 0}
                                </Typography>
                            </Box>
                        </Paper>
                      
                        {showSupplier &&
                            <div style={{ position: 'absolute', top: '20%', left: '30%', zIndex: 1, width: '100%' }}>
                                <SuppliersQuote
                                    data={suppliers?.data}
                                    loading={suppliers?.loading}
                                    setShowSupplier={setShowSupplier}
                                    enquiryType={'BOM'}
                                    handleView={handleView}
                                />
                            </div>
                        }
                    </Box>
                }
            </div>
        </>
    );
};

export default VendorOrderDetails;
